import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'absNumberFormat',
    standalone: true
})
export class AbsNumberFormatPipe implements PipeTransform {

    constructor() { }

    public transform(value: number | string,): string {

        let num = typeof value === 'number'
            ? value
            : Number(value)

        if (!num) {
            num = 0;
        }

        return `${Math.abs(num)}`;
    }
}
